const branches = [
  {
    slug: "western",
    name: {
      ar: "المنطقة الغربية",
      en: "Western Region",
    },
    cities: [
      {
        slug: "jeddah-andalus-mall",
        city: { ar: "جدة", en: "Jeddah" },
        mall: { ar: "الأندلس مول", en: "Al Andalus Mall" },
        gate: { ar: "بوابة 7", en: "Gate 7" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7988338.126537812!2d29.9914571!3d21.5056426!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3cf9f2cab2c53:0x6f76dcbc3dc8fee6!2z2LLYp9mK2LHZiNiz!5e1!3m2!1sar!2ssa!4v1772535866662!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/EwAwZA74ApgggvQ6A",
        },
      },
      {
        slug: "jeddah-yasmin-mall",
        city: { ar: "جدة", en: "Jeddah" },
        mall: { ar: "الياسمين مول", en: "Al Yasmin Mall" },
        gate: { ar: "بوابة 6", en: "Gate 6" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7988338.126537812!2d29.9914571!3d21.5056426!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3d1930a7de28b:0x82f9bdfd7c7192eb!2z2LLYp9mK2LHZiNiz!5e1!3m2!1sar!2ssa!4v1772535888633!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/JJ6sZtpT6ewg8dneA",
        },
      },
      {
        slug: "jeddah-aziz-mall",
        city: { ar: "جدة", en: "Jeddah" },
        mall: { ar: "عزيز مول", en: "Aziz Mall" },
        gate: { ar: "بين بوابة 1 وبوابة 4", en: "Between Gate 1 and Gate 4" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7984447.80320744!2d29.9698637!3d21.5763475!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3d11fcfaef8fd:0xbc4246d29f8e7a2!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772535912036!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/qxpFTzSQxz4DRjq46",
        },
      },
      {
        slug: "jeddah-park",
        city: { ar: "جدة", en: "Jeddah" },
        mall: { ar: "جدة بارك", en: "Jeddah Park" },
        gate: { ar: "بوابة 11", en: "Gate 11" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "2:00 م - 11:30 م", en: "2:00 PM - 11:30 PM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7984447.80320744!2d29.9698637!3d21.5763475!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3d197d70bfe29:0x3ab3f99387f43569!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772535940840!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/STsXLRCpGgk4hnMF9",
        },
      },
      {
        slug: "jeddah-the-village",
        city: { ar: "جدة", en: "Jeddah" },
        mall: { ar: "ذا فيليج", en: "The Village" },
        gate: { ar: "بوابة 2", en: "Gate 2" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "1:00 م - 6:00 م", en: "1:00 PM - 6:00 PM" },
          },
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:00 م - 3:00 ص", en: "9:00 PM - 3:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3893.323338702361!2d39.171290299999995!3d21.7736742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c17d31f7d7cd6b:0x7eb9235c5861d1c7!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772535979528!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/W5xjx8mrpGctt8s4A",
        },
      },
      {
        slug: "jeddah-u-walk",
        city: { ar: "جدة", en: "Jeddah" },
        mall: { ar: "يو ووك", en: "U Walk" },
        gate: null,
        status: "coming-soon",
        hours: null,
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6239.715972376656!2d39.13826820725684!3d21.579781613576!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3dbb04abdad9f%3A0x5a7cfadd54e17c10!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e0!3m2!1sen!2ssa!4v1785652926895!5m2!1sen!2ssa",
          url: null,
        },
      },
      {
        slug: "makkah-mall",
        city: { ar: "مكة", en: "Makkah" },
        mall: { ar: "مكة مول", en: "Makkah Mall" },
        gate: { ar: "بوابة 4", en: "Gate 4" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7915690.077115798!2d38.103575!3d22.7915436!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c2052dceec947f:0xe13f5fc7469fe57!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772536233314!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/pVNHrq2rkwVooVw88",
        },
      },
      {
        slug: "madinah-alnoor-mall",
        city: { ar: "المدينة المنورة", en: "Madinah" },
        mall: { ar: "النور مول", en: "Al Noor Mall" },
        gate: { ar: "بين بوابة 2 و3", en: "Between Gate 2 and Gate 3" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7988338.126537812!2d29.9914571!3d21.5056426!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15bdbfd4137c7887:0xc8533a36c2cb0203!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772536267375!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/pxuYsReBMQtAM8699",
        },
      },
      {
        slug: "madinah-alia-mall",
        city: { ar: "المدينة المنورة", en: "Madinah" },
        mall: { ar: "العالية مول", en: "Alia Mall" },
        gate: { ar: "بين بوابة 2 و3", en: "Between Gate 2 and Gate 3" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3817.521755905718!2d39.6191481!3d24.414960800000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15bdc131b192a925:0xdb55533024c51bc!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772536290096!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/k5nuv6RbfeNaRZXj9",
        },
      },
      {
        slug: "taif-jouri-mall",
        city: { ar: "الطائف", en: "Taif" },
        mall: { ar: "الجوري مول", en: "Jouri Mall" },
        gate: { ar: "بين بوابة 1 و2", en: "Between Gate 1 and Gate 2" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8000834.917422181!2d31.2162545!3d21.277005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15e98919472ba233:0xc41cdd1709a31474!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772537245993!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/eXFPiPXDpb5J77UJ9",
        },
      },
      {
        slug: "taif-the-park-mall",
        city: { ar: "الطائف", en: "Taif" },
        mall: { ar: "ذا بارك مول", en: "The Park Mall" },
        gate: { ar: "بوابة 1", en: "Gate 1" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "10:00 ص - 12:00 ص", en: "10:00 AM - 12:00 AM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8000834.917422181!2d31.2162545!3d21.277005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15ea2ff845353d8f:0xc670526c6257bd13!2z2LLYp9mK2LHZiNiz!5e1!3m2!1sar!2ssa!4v1772537286842!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/G48SHAAbsYLNY59v7",
        },
      },
      {
        slug: "yanbu-dana-mall",
        city: { ar: "ينبع", en: "Yanbu" },
        mall: { ar: "الدانة", en: "Al Dana" },
        gate: { ar: "بوابة 2", en: "Gate 2" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1960446.1997918042!2d35.8866263!3d24.0327562!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15b91bfae739fd55:0x5c567473eced5710!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772537304778!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/gKapqU6VQzSkTcR79",
        },
      },
    ],
  },

  {
    slug: "central-northern",
    name: {
      ar: "المنطقة الوسطى و الشمالية",
      en: "Central & Northern Region",
    },
    cities: [
      {
        slug: "riyadh-park-avenue",
        city: { ar: "الرياض", en: "Riyadh" },
        mall: { ar: "بارك افنيو", en: "Park Avenue" },
        gate: { ar: "بوابة 3", en: "Gate 3" },
        status: "new",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7915717.517535717!2d38.1042401!3d22.7910709!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2efd7e7053e629:0x8138538321853455!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772537356015!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/pnG9hDcf4GJG2Hmn6",
        },
      },
      {
        slug: "riyadh-othaim-mall",
        city: { ar: "الرياض", en: "Riyadh" },
        mall: { ar: "العثيم مول", en: "Othaim Mall" },
        gate: { ar: "بوابة 2", en: "Gate 2" },
        status: "new",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d951.8238343214158!2d46.820932!3d24.7509131!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f01b6a50b355b:0xeb41d88747dae32a!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772538176367!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/YNdznreywRbZJzXU9",
        },
      },
      {
        slug: "riyadh-alhamra-mall",
        city: { ar: "الرياض", en: "Riyadh" },
        mall: { ar: "الحمراء مول", en: "Al Hamra Mall" },
        gate: { ar: "بوابة 2", en: "Gate 2" },
        status: "coming-soon",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d121800.66916242571!2d46.6870191!3d24.7843316!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f01590556c757:0x665116a2d8d9e876!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772538190407!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/2sZ9ty98zMLTX3397",
        },
      },
      {
        slug: "riyadh-alqasr-mall",
        city: { ar: "الرياض", en: "Riyadh" },
        mall: { ar: "القصر مول", en: "Al Qasr Mall" },
        gate: null,
        status: "new",
        hours: null,
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3050.458949528299!2d46.69560309558357!3d24.60204900170575!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f051e11da4965%3A0x30d54d3087b03c7a!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e0!3m2!1sen!2ssa!4v1785652776465!5m2!1sen!2ssa",
          url: null,
        },
      },
      {
        slug: "qassim-nakheel-plaza",
        city: { ar: "القصيم - بريدة", en: "Qassim - Buraidah" },
        mall: { ar: "النخيل بلازا", en: "Nakheel Plaza" },
        gate: { ar: "بين بوابة 3 وبوابة 4", en: "Between Gate 3 and Gate 4" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7692709.889303005!2d34.7325346!3d26.3692323!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x157f59f7b9edf401:0x408c7f7e4558fe41!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772538252286!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/15BVfKYPb3j51brw5",
        },
      },
      {
        slug: "tabuk-park",
        city: { ar: "تبوك", en: "Tabuk" },
        mall: { ar: "تبوك بارك", en: "Tabuk Park" },
        gate: { ar: "بوابة 1", en: "Gate 1" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7550525.621089143!2d27.3441259!3d28.431066!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15a9b32f1095f223:0x4a4cefb10c51bd87!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772539420949!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/Aw4Bs3dgZkCqbVvJ9",
        },
      },
      {
        slug: "hail-othaim-mall",
        city: { ar: "حائل", en: "Hail" },
        mall: { ar: "العثيم مول", en: "Othaim Mall" },
        gate: { ar: "بين بوابة 1 و3", en: "Between Gate 1 and Gate 3" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1932035.1286336062!2d40.0610256!3d25.8318209!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15763f5fa90d9805:0xf0aa636ab2d509f9!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772539448939!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/cBNgUGPXMaCRD9AJ7",
        },
      },
      {
        slug: "arar-othaim-mall",
        city: { ar: "عرعر", en: "Arar" },
        mall: { ar: "العثيم مول", en: "Othaim Mall" },
        gate: null,
        status: "coming-soon",
        hours: null,
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8881330.76046012!2d39.65286517020398!3d23.938481713259396!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x156c13448fa8ecad%3A0x244a5a34aae9894e!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e0!3m2!1sen!2ssa!4v1785652540973!5m2!1sen!2ssa",
          url: null,
        },
      },
    ],
  },

  {
    slug: "eastern",
    name: {
      ar: "المنطقة الشرقية",
      en: "Eastern Region",
    },
    cities: [
      {
        slug: "dammam-nakheel-mall",
        city: { ar: "الشرقية", en: "Eastern Province" },
        mall: { ar: "النخيل مول", en: "Nakheel Mall" },
        gate: { ar: "بوابة 3", en: "Gate 3" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "2:00 م - 12 بعد منتصف الليل", en: "2:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d480700.1604617275!2d49.552389!3d26.3918697!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49fd9bd0bdb1e1:0x6015f902794c87d4!2z2LLYp9mK2LHZiNiz!5e1!3m2!1sar!2ssa!4v1772538335654!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/jdDopcCLtHHbxmU26",
        },
      },
      {
        slug: "dammam-dareen-mall",
        city: { ar: "الشرقية", en: "Eastern Province" },
        mall: { ar: "دارين مول", en: "Dareen Mall" },
        gate: { ar: "بوابة 3", en: "Gate 3" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "10:00 ص - 11:00 م", en: "10:00 AM - 11:00 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 11:00 م", en: "3:00 PM - 11:00 PM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7915690.077115798!2d38.103575!3d22.7915436!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49ff8b191b96e5:0x29f02b78910c5f0b!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772538373271!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/Tz6gf7zAHjyPNy436",
        },
      },
      {
        slug: "khobar-flamingo-park",
        city: { ar: "الشرقية", en: "Eastern Province" },
        mall: { ar: "فلامنجو بارك", en: "Flamingo Park" },
        gate: { ar: "بوابة 2", en: "Gate 2" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:00 م", en: "9:30 AM - 11:00 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 11:00 م", en: "3:00 PM - 11:00 PM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d481133.5475255727!2d49.6046013!3d26.2875801!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49e7bf337abde3:0xee1a12996889d92d!2z2LLYp9mK2LHZiNizINmB2LHYuSDZgdmE2KfZhdmG2KzZiA!5e1!3m2!1sar!2ssa!4v1772538407677!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/FhsaXanscSTYjMAc9",
        },
      },
      {
        slug: "khobar-shubaily-mall",
        city: { ar: "الخبر", en: "Khobar" },
        mall: { ar: "الشبيلي مول", en: "Shubaily Mall" },
        gate: null,
        status: "coming-soon",
        hours: null,
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3760.803547036204!2d50.210928599999995!3d26.227412899999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49c300726ca9ff:0x90583f9b73278948!2z2KfZhNi02KjZitmE2Yog2KzYsdin2YbYryDZhdmI2YQ!5e1!3m2!1sar!2ssa!4v1772539127670!5m2!1sar!2ssa",
          url: null,
        },
      },
      {
        slug: "ahsa-othaim-mall",
        city: { ar: "الأحساء", en: "Al Ahsa" },
        mall: { ar: "العثيم مول", en: "Othaim Mall" },
        gate: { ar: "مقابل بوابة رقم 3", en: "Opposite Gate 3" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "1:00 م - 12 بعد منتصف الليل", en: "1:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d242282.03180324906!2d49.3400363!3d25.4480644!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e3796574b3afe87:0x4d005e16fc9a5367!2z2KfZhNi52KvZitmFINmF2YjZhA!5e1!3m2!1sar!2ssa!4v1772539233566!5m2!1sar!2ssa",
          url: "https://goo.gl/maps/7jxrW8eStaFWFxh47",
        },
      },
      {
        slug: "ahsa-mall",
        city: { ar: "الأحساء", en: "Al Ahsa" },
        mall: { ar: "الأحساء مول", en: "Al Ahsa Mall" },
        gate: { ar: "بوابة 3", en: "Gate 3" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:00 م", en: "9:30 AM - 11:00 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d485042.38879732427!2d48.9730731!3d25.3289505!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e3791d572de0959:0x82613f25a38c94fc!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772539219930!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/h1HmQtJZ37KEbiEq8",
        },
      },
      {
        slug: "jubail-mall",
        city: { ar: "الجبيل", en: "Jubail" },
        mall: { ar: "الجبيل مول", en: "Jubail Mall" },
        gate: { ar: "بوابة 1", en: "Gate 1" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الجمعة", en: "Saturday to Friday" },
            time: { ar: "11:30 ص - 2:30 ص", en: "11:30 AM - 2:30 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d466.9193286406969!2d49.659101!3d27.0037488!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e35a1b2e445e427:0x4d0c622664c83d72!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772539249212!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/WnJWjtkPSP8zA1wTA",
        },
      },
      {
        slug: "khafji-othaim-mall",
        city: { ar: "الخفجي", en: "Khafji" },
        mall: { ar: "العثيم مول", en: "Othaim Mall" },
        gate: { ar: "بوابة 2", en: "Gate 2" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "1:00 م - 12 بعد منتصف الليل", en: "1:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3687.0897493307803!2d48.482369!3d28.4221759!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcc1d077348bd33:0x95364d642933b135!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772539265827!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/DPLoGLgAY39eTxkx6",
        },
      },
    ],
  },

  {
    slug: "southern",
    name: {
      ar: "المنطقة الجنوبية",
      en: "Southern Region",
    },
    cities: [
      {
        slug: "khamis-mushait-mojan-park",
        city: { ar: "خميس مشيط", en: "Khamis Mushait" },
        mall: { ar: "موجان بارك", en: "Mojan Park" },
        gate: { ar: "بوابة 1", en: "Gate 1" },
        status: "new",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:30 م - 12 بعد منتصف الليل", en: "3:30 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d995.1864403964274!2d42.7391414!3d18.2847847!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15fb5915d330107f:0xc98531af61bbfd77!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772539620347!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/vkPwttGkLeM37SuM7",
        },
      },
      {
        slug: "baha-mall",
        city: { ar: "الباحة", en: "Al Baha" },
        mall: { ar: "الباحة مول", en: "Al Baha Mall" },
        gate: {
          ar: "بين بوابة 1 وبوابة 2 - الدور الأول",
          en: "Between Gate 1 and Gate 2 - First Floor",
        },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "3:30 م - 11:30 م", en: "3:30 PM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:30 م - 12 بعد منتصف الليل", en: "3:30 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3937.773273659366!2d41.528152999999996!3d20.072548400000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15ef4111b1a405e7:0x87549ea74d9eb604!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772539635473!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/8Pu6LG8XWzc7gUzn6",
        },
      },
      {
        slug: "abha-lavenda-park",
        city: { ar: "أبها", en: "Abha" },
        mall: { ar: "لافاندا بارك", en: "Lavanda Park" },
        gate: { ar: "بوابة 2", en: "Gate 2" },
        status: "new",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:30 م - 12 بعد منتصف الليل", en: "3:30 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d995.4430266329239!2d42.6040349!3d18.2400243!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15fcab789f830915:0x13ea78f38a4a1050!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772539649348!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/TcsvkUE61mvY7gMB8",
        },
      },
      {
        slug: "jazan-kadi-mall",
        city: { ar: "جيزان", en: "Jazan" },
        mall: { ar: "كادي مول", en: "Kadi Mall" },
        gate: { ar: "بين بوابة 3 و4", en: "Between Gate 3 and Gate 4" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:30 م - 12 بعد منتصف الليل", en: "3:30 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4011.1803952700902!2d42.546563299999995!3d16.908931!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x160809de32a2fa8f:0xf859957e12802d78!2zenlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772539662506!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/SqbpCurNfjGxGgYY9",
        },
      },
      {
        slug: "najran-park",
        city: { ar: "نجران", en: "Najran" },
        mall: { ar: "نجران بارك مول", en: "Najran Park Mall" },
        gate: { ar: "بوابة 1", en: "Gate 1" },
        status: "open",
        hours: [
          {
            days: { ar: "من السبت إلى الخميس", en: "Saturday to Thursday" },
            time: { ar: "9:30 ص - 11:30 م", en: "9:30 AM - 11:30 PM" },
          },
          {
            days: { ar: "الجمعة", en: "Friday" },
            time: { ar: "3:00 م - 12 بعد منتصف الليل", en: "3:00 PM - 12:00 AM" },
          },
        ],
        map: {
          embed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1998.6478615928343!2d44.251841!3d17.5495743!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15fedd55a876cdb3:0x9b33545a3ca1f417!2zWnlyb3MgfCDYstin2YrYsdmI2LM!5e1!3m2!1sar!2ssa!4v1772539673466!5m2!1sar!2ssa",
          url: "https://maps.app.goo.gl/fs6NQCBcvF99w2gH7",
        },
      },
    ],
  },
];

export default branches;